// components/Contact/ContactInfo.jsx
import React from "react";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";

export default function ContactInfo() {
  return (
    <MKBox textAlign="center" mt={8}>
      <MKTypography variant="body2">info@matrix180.co.uk </MKTypography>
      <MKTypography variant="body2">sales@matrix180.co.uk </MKTypography>
      <MKTypography variant="body2">+447498467748</MKTypography>
      <MKTypography variant="body2">Nottingham, UK</MKTypography>
    </MKBox>
  );
}
